<template>
  <div class="staff">
    <div class="sta_center">
      <el-tabs
        v-model="activeName"
        class="demo-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :label="proxy.$t('material.MyGallery')"
          name="first"
        />
      </el-tabs>
      <div
        v-show="activeName == 'first'"
        :class="['staffBox', { pathType: props.pathType == 2 }]"
      >
        <div class="store">
          <div class="storeList">
            <el-tree
              style="max-width: 600px"
              :data="materialCategoryData"
              :props="treeProps"
              node-key="id"
              :default-expanded-keys="['-1']"
              @node-click="handleNodeClick"
              @node-expand="handleNodeExpand"
              @click="handleTreeClick"
            >
              <template #default="{ data }">
                <div :class="['item', { active: data.id == categoryId }]">
                  <div class="item_l">
                    <svg-icon :icon-class="data.id == '-1' ? 'brandManag' : 'work'" />
                    <el-tooltip
                      :content="data.label"
                      placement="top"
                      :disabled="data.label.length <= 10"
                    >
                      <span class="sneme">{{ data.label }}</span>
                    </el-tooltip>
                  </div>
                  <div class="item_r">
                    <div :class="['count', { isBrand: data.id == '-1' }]">
                      {{ data.count }}
                    </div>
                    <div
                      v-hasPermi="['brand:material:category:add', 'brand:material:category:edit', 'brand:material:category:remove']"
                      :class="['puls', { isBrand: data.id == '-1' }]"
                      @click.stop
                    >
                      <div v-hasPermi="['brand:material:category:edit', 'brand:material:category:remove']">
                        <el-dropdown
                          teleport="false"
                          @click.prevent.stop
                          @command="commandMaterial($event, data)"
                        >
                          <el-icon
                            :class="['icon', { isIcon: data.id == '-1' }]"
                            @click.prevent.stop
                          >
                            <MoreFilled />
                          </el-icon>
                          <template
                            v-if="data.id != '-1'"
                            #dropdown
                          >
                            <el-dropdown-menu>
                              <div v-hasPermi="['brand:material:category:edit']">
                                <el-dropdown-item command="2">
                                  {{ proxy.$t('material.newNmae') }}
                                </el-dropdown-item>
                              </div>
                              <div v-hasPermi="['brand:material:category:remove']">
                                <el-dropdown-item command="3">
                                  {{ proxy.$t('Shared.del') }}
                                </el-dropdown-item>
                              </div>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div v-hasPermi="['brand:material:category:add']">
                        <el-dropdown
                          teleport="false"
                          @click.prevent.stop
                          @command="commandMaterial($event, data)"
                        >
                          <el-icon class="icon">
                            <Plus />
                          </el-icon>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <el-dropdown-item command="1">
                                {{ proxy.$t('material.new') }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-tree>
          </div>
        </div>
        <div class="centerBox">
          <div class="cen_her">
            <!-- <el-input
              class="mateinput"
              @blur="onSearch"
              @keyup.enter="onSearch"
              @clear="onSearch"
              clearable
              v-model="pageParams.name"
              :placeholder="proxy.$t('Shared.pleaseEnter') + proxy.$t('material.workName')"
              :prefix-icon="Search"
            /> -->
            <search
              :searchDate="searchDate"
              :loading="listLoading"
              @search="handleQuery"
            />
            <div style="display: flex">
              <el-button
                v-show="batchType == 1 && props.pathType != 2"
                v-hasPermi="['brand:material:move', 'brand:material:remove']"
                type="primary"
                plain
                style="margin-inline-end: 10px"
                @click="batchType = 2"
              >
                {{
                  proxy.$t('Shared.BatchOperation')
                }}
              </el-button>
              <imageUpload
                v-hasPermi="['brand:material:add']"
                :category-id="categoryId"
                :limit="9"
                @is-update="Update"
              />
            </div>
            <div
              v-show="batchType == 2"
              class="batchBox"
            >
              <span class="batchTip">
                {{ proxy.$t('Shared.Selected') }} <span class="conut">{{ materialActiveList.length }} </span> {{ proxy.$t('Unit.zhang') }}
              </span>
              <el-button
                v-hasPermi="['brand:material:move']"
                type="primary"
                link
                :disabled="materialActiveList.length == 0"
                @click="materialPorFn(1)"
              >
                {{ proxy.$t('material.move') }}
              </el-button>
              <el-button
                v-hasPermi="['brand:material:remove']"
                type="danger"
                link
                :disabled="materialActiveList.length == 0"
                @click="materialPorFn(2)"
              >
                {{ proxy.$t('Shared.del') }}
              </el-button>
              <el-button
                type="info"
                link
                @click="onCen"
              >
                {{ proxy.$t('Shared.Cancel') }}
              </el-button>
            </div>
          </div>
          <div class="cen">
            <div class="cen_l">
              <div class="list">
                <div
                  v-for="item in materialList"
                  :key="item.materialId"
                  :class="['image-item', { active: activeMateFn(item) }, { onbatchType: batchType == 2 }]"
                >
                  <div
                    class="itemBox"
                    @click="onItem(item)"
                  >
                    <img
                      draggable="false"
                      class="imgea"
                      :src="item.displayPath || item.path"
                      alt=""
                      srcset=""
                    >
                    <div
                      v-show="activeMateFn(item)"
                      class="state-check"
                    >
                      <el-icon class="el-icon-check">
                        <Select />
                      </el-icon>
                    </div>
                    <div class="image-title-bg">
                      <div class="image-name">
                        {{ item.name }}
                      </div>
                      <div class="itemOperation">
                        <el-icon
                          class="iccon"
                          @click.stop="onoPerationFn(1, item)"
                        >
                          <ZoomIn />
                        </el-icon>
                        <el-icon
                          v-hasPermi="['brand:material:edit']"
                          class="iccon"
                          @click.stop="onoPerationFn(2, item)"
                        >
                          <Crop />
                        </el-icon>
                        <el-icon
                          class="iccon"
                          @click.stop="onoPerationFn(3, item)"
                        >
                          <Download />
                        </el-icon>
                        <el-icon
                          v-hasPermi="['brand:material:remove']"
                          class="iccon"
                          @click.stop="onoPerationFn(4, item)"
                        >
                          <Delete />
                        </el-icon>
                      </div>
                    </div>
                  </div>
                </div>
                <antEmpty
                  v-show="total == 0"
                  icon="empty2"
                  :title="proxy.$t('material.empty1')"
                  size="300px"
                />
              </div>

              <div class="pagination">
                <div />
                <el-pagination
                  v-model:current-page="pageParams.pageNum"
                  v-model:page-size="pageParams.pageSize"
                  :page-sizes="[60, 120, 300, 500]"
                  :size="size"
                  :disabled="disabled"
                  layout="sizes, prev, pager, next"
                  :total="total"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="cen_r">
              <div class="itemDetail">
                <div
                  v-for="item in materialActiveList"
                  :key="item.materialId"
                  :class="[{ item: batchType == 2 }]"
                >
                  <!-- 图片详情 -->
                  <div
                    v-show="batchType == 1 && props.pathType != 2"
                    class="qm_pic"
                  >
                    <div class="image_box">
                      <img
                        class="image"
                        :src="item.displayPath || item.path"
                      >
                    </div>
                    <div class="formBox">
                      <div class="form-item">
                        <div class="label">
                          {{ proxy.$t('material.workName') }}：
                        </div>
                        <div
                          v-show="!nameShow"
                          class="conter"
                        >
                          <span class="truncate">{{ item.name }}</span>
                          <el-icon
                            v-hasPermi="['brand:material:edit']"
                            class="sealicon"
                            @click="nameShow = true"
                          >
                            <EditPen />
                          </el-icon>
                        </div>
                        <div
                          v-show="nameShow"
                          class="conter"
                        >
                          <el-input
                            v-model="item.name"
                            style="width: 120px"
                          />
                          <el-icon
                            v-hasPermi="['brand:material:edit']"
                            class="sealicon remark"
                            :class="{ 'is-loading': materialSaving }"
                            @click="editTip(item)"
                          >
                            <Loading v-if="materialSaving" />
                            <Select v-else />
                          </el-icon>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="label">
                          {{ proxy.$t('material.Filepath') }}：
                        </div>
                        <div class="conter">
                          <span class="truncate">{{ item.displayPath || item.path }}</span>
                          <el-icon
                            class="sealicon"
                            @click="handleCopyFn(item)"
                          >
                            <CopyDocument />
                          </el-icon>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="label">
                          {{ proxy.$t('material.FileSize') }}：
                        </div>
                        <div class="conter">
                          <span class="truncate">{{ item.sizeKb }}KB</span>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="label">
                          {{ proxy.$t('material.FileProportion') }}：
                        </div>
                        <div class="conter">
                          <span class="truncate">{{ item.width }}X{{ item.height }}</span>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="label">
                          {{ proxy.$t('material.UploadTime') }}：
                        </div>
                        <div class="conter">
                          <span class="truncate">{{ formatViewTime(item.createTime) }}</span>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="label">
                          {{ proxy.$t('material.updateTime') }}：
                        </div>
                        <div class="conter">
                          <span class="truncate">{{ formatViewTime(item.updateTime) }}</span>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="label">
                          {{ proxy.$t('material.remark') }}：
                        </div>
                        <div
                          v-show="!remarkShow"
                          class="conter"
                        >
                          <span class="truncate">{{ item.remark }}</span>
                          <el-icon
                            v-hasPermi="['brand:material:edit']"
                            class="sealicon"
                            @click="remarkShow = true"
                          >
                            <EditPen />
                          </el-icon>
                        </div>
                        <div
                          v-show="remarkShow"
                          class="conter"
                        >
                          <el-input
                            v-model="item.remark"
                            style="width: 120px"
                          />
                          <el-icon
                            v-hasPermi="['brand:material:edit']"
                            class="sealicon remark"
                            :class="{ 'is-loading': materialSaving }"
                            @click="editTip(item)"
                          >
                            <Loading v-if="materialSaving" />
                            <Select v-else />
                          </el-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img
                    v-show="batchType == 2 || props.pathType == 2"
                    class="image"
                    :src="item.displayPath || item.path"
                  >
                </div>
              </div>

              <antEmpty
                v-show="materialActiveList.length == 0"
                :title="proxy.$t('material.empty2')"
              />
              <el-button
                v-show="props.pathType == 2"
                class="pathTypeBtn"
                type="primary"
                style="width: 80%; margin: 0 auto"
                @click="onCheck"
              >
                {{ proxy.$t('Shared.Insert') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 删除目录 -->
    <el-dialog
      v-model="dialogVisible"
      :title="proxy.$t('material.delWork')"
      width="470"
      :before-close="handleClose"
    >
      <div class="btnBox">
        <div
          :class="['del-tree-con', { 'active': delType == 2 }]"
          @click="delType = 2"
        >
          <el-icon class="itemcCing">
            <TrendCharts />
          </el-icon>{{ proxy.$t('material.delTitle') }}
          <div
            v-show="delType == 2"
            class="state-check"
          >
            <el-icon class="el-icon-check">
              <Select />
            </el-icon>
          </div>
        </div>
        <div
          :class="['del-tree-con', { 'active': delType == 1 }]"
          @click="delType = 1"
        >
          <el-icon class="itemcCing">
            <TrendCharts />
          </el-icon>{{ proxy.$t('material.delTitles') }}
          <div
            v-show="delType == 1"
            class="state-check"
          >
            <el-icon class="el-icon-check">
              <Select />
            </el-icon>
          </div>
        </div>

        <div
          v-show="delType == 2"
          class="tip"
        >
          <el-icon class="tipIcon">
            <Warning />
          </el-icon> {{ proxy.$t('material.delTitleTip') }}
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">
            {{ proxy.$t('Shared.Cancel') }}
          </el-button>
          <el-button
            type="primary"
            @click="materialCateDel"
          >
            {{ proxy.$t('Shared.del') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <addbrandMaterial
      ref="addbrandMaterialRef"
      @update="getcategoryTreeList"
    />
    <ImageFullScreen
      :is-full-screen="isFullScreen"
      :image="currentImageUrl"
      @is-full-screen-fn="isFullScreenFn"
    />
    <!-- 批量移动 -->
    <moveMaterialModel
      ref="moveMaterialModelRef"
      :work-list="materialCategoryData"
      @update="onMoveMaterial"
    />

    <!-- 裁剪 -->
    <ImageCropper
      :category-id="categoryId"
      :visible="imageSrcVisible"
      :image-src="imageSrc"
      @close="imageSrcVisible = false"
      @confirm="handleCropConfirm"
    />
  </div>
</template>
<!-- eslint-disable-next-line vue/block-lang -- 旧组件保留 JavaScript，避免仅为规则迁移脚本语言 -->
<script setup>
import { getInputValidationError, normalizeSearchParams } from '@/utils/form/inputRules';
import { ref, onMounted, watch, defineProps } from 'vue';
const { proxy } = getCurrentInstance();
import { categoryTreeListApi, removeCategoryApi, removeMaterialApi, editMaterialApi, materialListApi } from '@/api/brand/material';
import { utcToCurrentLocalTime } from '@/utils/dateUTC';
import { resolveImageDisplayUrl } from '@/utils/image';
import { useBrandStore } from '@/store/modules/brand.ts';
import addbrandMaterial from './components/addbrandMaterial.vue';
import moveMaterialModel from './components/moveMaterialModel.vue';
import { handleCopy, downloadImageFromElement, reliableImageLoad } from '@/utils/index';
import ImageFullScreen from '@/components/ImagePreview/ImageFullScreen.vue';
import ImageCropper from '@/components/ImageUpload/ImageCropper.vue';
const emits = defineEmits(['onCheck']);

const formatViewTime = (value) => (value ? utcToCurrentLocalTime(value) : '-');

const props = defineProps({
  pathType: {
    type: Number,
    default: 1,
  },
  materialNum: {
    type: Number,
    default: 1,
  },
  checkList: {
    // 选择的图片
    type: Number,
    default: 0,
  },
  prop: {
    type: Object,
    default: () => {
      return { img: 'img', id: 'id' };
    },
  },
});
const searchDate = ref([{ id: 2, type: 1, title: proxy.$t('material.workName'), fixed: true, show: false, value: '', fieldName: 'name' }]);
const imageSrcVisible = ref(false);
const imageSrc = ref(''); // 需要裁剪的图片
const brandStore = useBrandStore();
const currentImageUrl = ref('');
const isFullScreen = ref(false);
const activeName = ref('first');
const materialCategoryData = ref([]);
const materialList = ref([]);
const materialActiveList = ref([]);
const addbrandMaterialRef = ref(null);
const moveMaterialModelRef = ref(null);
const delMaterialModel = ref(null); // 删除暂存
const dialogVisible = ref(false);
const categoryId = ref('-1');
const delType = ref(2);
const batchType = ref(1); // 1单一操作   2批量操作
const remarkShow = ref(false);
const nameShow = ref(false);
const total = ref(0);
const pageParams = ref({
  pageNum: 1,
  pageSize: 60,
  name: '',
  categoryId: '-1',
});
watch(
  () => categoryId.value,
  () => {
    updateMaterial();
  },
  { deep: true },
);
watch(
  () => props.checkList,
  (val) => {
    console.log('val----------', val);
  },
);
onMounted(() => {
  materialCategoryData.value = [
    {
      id: '-1',
      label: brandStore.state.brandName,
      count: 12,
      children: [],
    },
  ];
  getcategoryTreeList();
  getMaterialList();
});
const oncheckList = () => {
  materialActiveList.value = [];
  props.checkList.forEach((v) => {
    const path = v[props.prop.img];
    materialActiveList.value.push({
      path,
      // 展示地址与原始路径分离，选择确认时仍回传 path。
      displayPath: resolveImageDisplayUrl(path),
      materialId: v[props.prop.id],
    });
  });
};
const onCheck = () => {
  if (props.materialNum < materialActiveList.value.length) {
    ElMessage({
      message: `${proxy.$t('Shared.maxSelected')}${props.materialNum}${proxy.$t('Unit.zhang')}`,
      type: 'warning',
    });
    return;
  }
  // 选择结果移除展示字段，父组件和后端始终只接收原始 path。
  const selections = materialActiveList.value.map((item) => {
    const selection = { ...item };
    delete selection.displayPath;
    return selection;
  });
  emits('onCheck', selections);
};
const handleCropConfirm = () => {
  Update();
};
// 图片操作
const onoPerationFn = (type, item) => {
  console.log('item-------', item);
  const displayPath = item.displayPath || item.path;
  if (type == 1) {
    // 预览
    currentImageUrl.value = displayPath;

    isFullScreen.value = true;
  } else if (type == 2) {
    // 裁剪
    imageSrc.value = displayPath;
    imageSrcVisible.value = true;
  } else if (type == 3) {
    // 下载
    // window.open(path)
    reliableImageLoad(displayPath).then((img) => {
      downloadImageFromElement(img, item.name);
    });
  } else {
    // 删除
    materialPorFn(2, [item.materialId]);
  }
};
// 编辑素材
const materialSaving = ref(false);
const editTip = async (data) => {
  if (materialSaving.value) return;
  const params = normalizeSubmitData({ ...data }, { name: 'naturalText', remark: 'naturalText' });
  const t = (key, values) => proxy.$t(key, values);
  for (const field of ['name', 'remark']) {
    const error = getInputValidationError(t, params[field], { strategy: 'naturalText', required: field === 'name' });
    if (error) return ElMessage.warning(error);
  }
  delete params.displayPath;
  materialSaving.value = true;
  try {
    const res = await editMaterialApi(params);
    if (res.code == 200) {
      remarkShow.value = false;
      nameShow.value = false;
      ElMessage.success(t('Shared.editMessage'));
      await getMaterialList();
    }
  } catch {
    // 失败时保留正在编辑的内容。
  } finally {
    materialSaving.value = false;
  }
};
function isFullScreenFn() {
  isFullScreen.value = false;
}
// 页码
const handleChange = () => {
  getMaterialList();
};
// 复制
const handleCopyFn = (item) => {
  handleCopy(item.displayPath || item.path);
};

// 选择素材
const onItem = (item) => {
  remarkShow.value = false;
  nameShow.value = false;
  if (batchType.value == 1 && props.materialNum == 1) {
    // 单选
    if (materialActiveList.value.length > 0 && materialActiveList.value[0].materialId == item.materialId) {
      materialActiveList.value = [];
    } else {
      materialActiveList.value = [item];
    }
  } else {
    // 多选
    const arr = materialActiveList.value.map((v) => {
      return v.materialId;
    });
    if (arr.includes(item.materialId)) {
      materialActiveList.value = materialActiveList.value.filter((v) => {
        return v.materialId != item.materialId;
      });
    } else {
      if (arr.length == props.materialNum && batchType.value != 2) {
        ElMessage({
          message: `${proxy.$t('Shared.maxSelected')}${props.materialNum}${proxy.$t('Unit.zhang')}`,
          type: 'warning',
        });
        return;
      }
      materialActiveList.value.push(item);
    }
  }
};
// 是否展示选择样式
const activeMateFn = (item) => {
  const arr = materialActiveList.value.map((v) => {
    return v.materialId;
  });
  return arr.includes(item.materialId);
};

const handleNodeClick = (e) => {
  categoryId.value = e.id;
};
const materialCateDel = () => {
  // 删除
  const data = {
    newCategoryId: delType.value == 2 ? '-1' : null,
    categoryId: delMaterialModel.value.id,
  };
  removeCategoryApi(data).then((res) => {
    if (res.code == 200) {
      dialogVisible.value = false;
      getcategoryTreeList();
      if (data.categoryId == categoryId.value) {
        categoryId.value = '-1';
      }
      updateMaterial();
      ElMessage({
        message: proxy.$t('Shared.success'),
        type: 'success',
      });
    }
  });
};
// 新增类别
const commandMaterial = (type, data) => {
  if (type == 3) {
    delMaterialModel.value = data;
    // 删除
    dialogVisible.value = true;
  } else {
    // 新建
    addbrandMaterialRef.value.visibleFn(type == 1 ? 'add' : 'edit', data);
  }
};
const getcategoryTreeList = () => {
  categoryTreeListApi().then((res) => {
    const { categoryTree, count } = res.data;
    materialCategoryData.value[0].count = count;
    materialCategoryData.value[0].children = categoryTree;
  });
};
//
const onMoveMaterial = () => {
  materialActiveList.value = [];
  batchType.value = 1;
  getcategoryTreeList();
  getMaterialList();
};
// 筛选素材
const updateMaterial = () => {
  pageParams.value.pageNum = 1;
  pageParams.value.pageSize = 60;
  getMaterialList();
};
// 获取素材
const listLoading = ref(false);
let listRequestSequence = 0;
const getMaterialList = async () => {
  const sequence = ++listRequestSequence;
  pageParams.value.categoryId = categoryId.value;
  const params = normalizeSearchParams({ ...pageParams.value }, ['name']);
  listLoading.value = true;
  try {
    const res = await materialListApi(params);
    if (sequence !== listRequestSequence) return;
    if (res.code == 200) {
      materialList.value = res.data.records.map((item) => ({
        ...item,
        // 原始 path 用于业务提交，完整地址仅供界面展示和访问。
        displayPath: resolveImageDisplayUrl(item.path),
      }));
      total.value = res.data.total;
    }
  } catch {
    // 公共请求封装提示失败，保留筛选输入并允许重试。
  } finally {
    if (sequence === listRequestSequence) listLoading.value = false;
  }
};
// 图片上传成功回掉
const Update = () => {
  ElMessage({
    message: proxy.$t('Shared.success'),
    type: 'success',
  });
  // 刷新目录
  getcategoryTreeList();
  // 筛选列表
  updateMaterial();
};
// 搜索
const handleQuery = (e) => {
  if (listLoading.value) return;
  pageParams.value.name = e.name ?? '';
  pageParams.value.pageNum = 1;
  // 筛选列表
  updateMaterial();
};
// 取消
const onCen = () => {
  // 筛选列表
  materialActiveList.value = [];
  batchType.value = 1;
};
// 移动  删除
const materialPorFn = async (type, data) => {
  const arr = materialActiveList.value.map((v) => {
    return v.materialId;
  });
  if (type == 1) {
    moveMaterialModelRef.value.visibleFn(arr);
  } else {
    // 删除
    await ElMessageBox.confirm(proxy.$t('material.deleteTip'), proxy.$t('Shared.Prompt'), {
      confirmButtonText: proxy.$t('Shared.Confirm'),
      cancelButtonText: proxy.$t('Shared.Cancel'),
      type: 'warning',
    });

    removeMaterialApi(data ? data : arr).then((res) => {
      if (res.code == 200) {
        ElMessage({
          message: proxy.$t('Shared.success'),
          type: 'success',
        });
        getcategoryTreeList();
        getMaterialList();
        batchType.value = 1;
        materialActiveList.value = [];
      }
    });
  }
};
defineExpose({
  oncheckList,
});
</script>
<style lang="scss" scoped>
:deep(.el-tabs__active-bar) {
  // display: none !important;
}

:deep(.el-tree) {
  --el-tree-node-content-height: 40px !important;
}

:deep(.el-tabs__header) {
  margin-bottom: 0 !important;
}

:deep(.el-tabs__nav-scroll) {
  padding-inline-start: 20px;
}

:deep(.el-tree-node__expand-icon.is-leaf) {
  // display: none;
}

:deep(.el-tree-node.is-current > .el-tree-node__content) {
  background-color: var(--bg-1) !important;
  /* 示例：浅蓝色，可替换为任意颜色 */
}

.staff {
  height: 100%;

  .sta_center {
    background: #fff;
    min-height: 100%;

    .staffBox {
      display: flex;
      height: calc(100vh - 160px);
      &.pathType {
        height: 670px !important;
      }
      .store {
        width: 400px;
        padding: 0 6px;
        border-inline-end: 1px solid #eee;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 0px; /* 垂直滚动条宽度设为6px */
        }
        .storeList {
          margin-top: 30px;
          color: #333;

          .item {
            width: 100%;
            display: flex;
            position: relative;
            padding: 10px 0;
            padding-inline-end: 110px;
            border-radius: 5px;
            box-sizing: border-box;

            &.active {
              color: var(--color-1);
              .icon {
                color: var(--color-1);
              }
            }
            &:hover {
              .item_r {
                .puls {
                  opacity: 1;
                  visibility: visible;
                  transform: translateX(0);
                }
              }
            }
            .icon {
              transform: rotate(90deg);
              margin-inline-start: 5px;
              &.isIcon {
                opacity: 0;
              }
            }

            .item_l {
              flex: 1;
              min-width: 0;
              display: flex;
              align-items: center;
              font-size: 14px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              .source {
                position: relative;
                top: 3px;
              }

              .sneme {
                margin-inline-start: 5px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .item_r {
              width: 100px;
              position: absolute;
              inset-inline-end: 15px;
              top: 50%;
              transform: translateY(-50%);
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 5px;
              .count {
                flex-shrink: 0;
                min-width: 20px;
                text-align: right;
                font-size: 14px;
                white-space: nowrap;
              }
              .puls {
                opacity: 0;
                visibility: hidden;
                transform: translateX(35px);
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 4px;
                &.isBrand {
                  opacity: 1;
                  visibility: visible;
                  transform: translateX(0);
                }
              }
            }
          }
        }
      }
    }
  }
}
.centerBox {
  width: 100%;
  .cen_her {
    height: 60px;
    width: 100%;
    border-bottom: 1px #eee solid;
    display: flex;
    padding: 12px 15px;
    justify-content: space-between;
    position: relative;
    .mateinput {
      width: 240px;
    }
    .batchBox {
      position: absolute;
      inset-inline-end: 300px;
      line-height: 36px;
      .batchTip {
        font-size: 14px;
        margin-inline-end: 10px;
        .conut {
          font-weight: 600;
          color: var(--color-1);
        }
      }
    }
  }
  .cen {
    height: calc(100% - 61px);
    display: flex;
    .cen_l {
      flex: 1;
      height: 100%;
      .list {
        height: calc(100% - 61px);
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 20px;
        overflow-y: auto;
        align-content: flex-start;
        .image-item {
          flex: 0 0 10%;
          min-width: 150px;
          position: relative;
          box-sizing: border-box;
          width: 25%;
          height: 140px;
          padding: 8px;
          border-radius: 4px;
          cursor: pointer;
          &:hover {
            .itemBox {
              border: 2px solid var(--color-1);
              border-radius: 4px;
              .image-title-bg {
                .image-name {
                  display: none;
                }
                .itemOperation {
                  display: block;
                  width: 100%;
                  line-height: 36px;
                  font-size: 16px;
                  font-weight: 700;
                  display: flex;
                  justify-content: space-around;
                  .iccon {
                    &:hover {
                      color: var(--color-1);
                    }
                  }
                }
              }
            }
          }
          &.active {
            .itemBox {
              border: 2px solid var(--color-1);
              border-radius: 4px;
            }
          }
          &.onbatchType {
            .itemBox {
              .image-title-bg {
                .image-name {
                  display: block !important;
                }
                .itemOperation {
                  display: none !important;
                }
              }
            }
          }
          .itemBox {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            height: 100%;
            border: 2px solid var(#fff, #ffffff);
            transition: all 0.3s ease 0s;
            .imgea {
              max-width: 100%;
              max-height: 100%;
              vertical-align: middle;
              border: none;
            }
            .image-title-bg {
              position: absolute;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: 49;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 30px;
              padding: 0 6px;
              color: #fff;
              font-size: 14px;
              background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.65)));
              .image-name {
                display: block;
                overflow: hidden;
                white-space: nowrap;
                text-align: center;
                text-overflow: ellipsis;
              }
              .itemOperation {
                display: none;
              }
            }
          }
        }
      }
      .pagination {
        padding: 20px 0;
        height: 60px;
        border-top: #f5f5f5 1px solid;
        display: flex;
        justify-content: space-between;
      }
    }
    .cen_r {
      width: 270px;
      height: 100%;
      border-inline-start: 1px #eee solid;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
      position: relative;
      .itemDetail {
        padding: 15px;
        height: calc(100% - 50px);
        overflow-y: auto;
      }
      .qm_pic {
        width: 230px;
        .image_box {
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          height: 150px;
          margin-bottom: 60px;
          padding: 0 20px;
          text-align: center;
          .image {
            max-width: 100%;
            max-height: 100%;
            vertical-align: middle;
            border: none;
          }
        }
        .form-item {
          display: flex;
          align-items: center;
          height: 40px;
          .label {
            flex: 0 0 80px;
            width: 80px;
            color: var(--color-5, #999999);
            font-size: 14px;
            text-align: right;
          }
          .conter {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: space-between;
            overflow: hidden;
            color: var(--color-2, #666666);
            font-size: 14px;
            .truncate {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .sealicon {
              margin-inline-start: 10px;
              cursor: pointer;
              font-size: 16px;
              &:hover {
                color: var(--color-1);
              }
              &.remark {
                color: var(--color-1);
                font-size: 18px;
              }
            }
          }
        }
      }
      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 114px;
        height: 100px;
        padding: 10px;
      }
      .image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        vertical-align: middle;
        border: none;
      }
      .pathTypeBtn {
        position: absolute;
        inset-inline-end: 8%;
        bottom: 10px;
      }
    }
  }
}
.btnBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  .del-tree-con {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 200px;
    height: 66px;
    color: var(--color, #333333);
    font-size: 16px;
    background: #f5f5f5;
    border-radius: 8px;
    cursor: pointer;
    .itemcCing {
      color: var(--color-1);
      font-size: 22px;
      margin-inline-end: 8px;
      margin-top: 2px;
    }
    &:hover {
      border: 2px solid var(--color-1);
    }
    &.active {
      border: 2px solid var(--color-1);
    }
  }
  .tip {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 30px;
    padding-top: 16px;
    color: var(--color-1);
    font-size: 14px;
    .tipIcon {
      margin-right: 5px;
      font-size: 16px;
    }
  }
}
.state-check {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  width: 0px;
  height: 0px;
  color: #fff;
  font-size: 12px;
  border-top: solid 30px var(--color-1);
  border-left: solid 30px rgba(0, 0, 0, 0);
  .el-icon-check {
    position: absolute;
    top: -26px;
    right: 1px;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
